<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>

    <!--  内容页  -->
    <!--  轮播图  -->
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">
    </div>

    <div class="container">

<!--      <van-list-->
<!--          v-model="loading"-->
<!--          :finished="finished"-->
<!--          finished-text="没有更多了"-->
<!--          @load="onLoad"-->
<!--      >-->
<!--        <van-cell v-for="item in newsList" :key="item" :title="item.title" />-->
<!--      </van-list>-->


      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="item in navList" :title="item.name" :key="item.index">
          <div class="newsList" style="margin-top: 20px;min-height: 480px;">
            <ul>
              <li v-for="item in newsList" :key="item.index" style="margin-bottom:5px;padding-bottom: 5px;">
                <router-link :to="{name:'ArticleContentYjj',params:{id:item.id,prevNav:'NewsListYjj',prevNavBar:active}}" >
                  <div style="display: flex;">
                    <div style="flex: 1;">
                      <img :src="item.imgsrc" style="width: 100%;height: 80px;">
                    </div>
                    <div style="flex: 3;padding:0 10px;height:80px;">
                      <h4 class="text-zhe" style="height: 40px;font-size: 16px;line-height: 20px;padding-top: 3px;">{{item.title}}</h4>
                      <p style="font-size:14px;height:20px;line-height: 15px;margin-top:20px;color:rgb(175,175,175);">{{item.createTime | dataFormat('yyyy-mm-dd')}}</p>
                    </div>
                  </div>
                  <van-divider style="margin-top:5px;margin-bottom: 0;" />
                </router-link>
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>


  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";


export default {
  name: "NewsListYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM,

  },
  data(){
    return{
      active: 1,
      activeFlag:'tongzhi',
      restfulUrl:'articles',
      columnName:1,
      newsList:[],
      navList:[
        {name:'通知公告',columnId:'tongzhi',},
        {name:'馆内动态',columnId:'dongtai',},
        {name:'规章制度',columnId:'zhidu',},
        {name:'政务公开',columnId:'gongkai',}
      ],
      loading: false,
      finished: false,
    }
  },
  methods:{


    onClick(name) {
      if(name == 0){
        this.getListByColumn(4)
      }
      if(name == 1){
        this.getListByColumn(5)
      }
      if(name == 'video'){
        this.getListByColumn(6)
      }
      if(name == 2){
        this.getListByColumn(31)
      }
      if(name == 3){
        this.getListByColumn(32)
      }
    },
    navCur(data){


      if(data == 0){

        this.getListByColumn(4)
      }
      if(data == 1){
        this.onLoad()
        this.getListByColumn(5)
      }
      if(data == 'video'){
        this.getListByColumn(6)
      }
      if(data == 2){
        this.onLoad()
        this.getListByColumn(31)
      }
      if(data == 3){
        this.onLoad()
        this.getListByColumn(32)
      }
    },
    getListByColumn(column){
      // 加载状态结束

      request({
        method:'POST',
        url:this.restfulUrl+'/getbycolumn',
        data:{columnId:column}
      }).then(res =>{
        if(res.data){
          this.newsList = res.data;
        }
      },err=>{
        console.log(err)
      })

    }
  },
  mounted() {
    this.getListByColumn(5)
  },
  filters:{
    dataFormat(input,pattern=''){
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');

      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');

        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;

      }

    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>
body{
  background: #e5e5e5;
}
a{
  color: black;
  text-decoration: none;
}
li{
  list-style: none;
  text-align: left;
}
img{
  width: 100%;
}
.container{
  padding: 10px;
}
.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}
.text-zhe{
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  overflow: hidden;
}
.van-cell::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 0px;
  bottom: 0;
  left: 0px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(.5);
  transform: scaleY(.5);
}
</style>
